import Vue from 'vue'
import Vuex from 'vuex'
import localforage from 'localforage'
import api from '../services/api'
import { misc } from './misc.module'
import { menu } from './menu.module'
import { auth } from './auth.module'
import { notifications } from './notifications.module'
import { crops } from './crops.module'
import { crop } from './crop.module'
import { protectors } from './protectors.module'
import { protector } from './protector.module'
import { quickSearch } from './quickSearch.module'
import { modal } from './modal.module'
import { note } from './note.module'
import { agrofags } from './agrofags.module'
import { agrofag } from './agrofag.module'
import { activeSubstances } from './activeSubstances.module'
import { activeSubstance } from './activeSubstance.module'
import { users } from './users.module'
import { user } from './user.module'
import { agriiProtectors } from './agriiProtectors.module'
import { agriiProtector } from './agriiProtector.module'
import { banner } from './banner.module'
import { alerts } from './alerts.module'
import { alert } from './alert.module'
import { photos } from './photos.module'
import { alertsForUser } from './alertsForUser.module'
import { settings } from './settings.module'
import { eko } from './eko.module'
import { termsAndConditions } from './termsAndConditions.module'
import { invoices } from './invoices.module'
import { subscriptions } from './subscriptions.module'
import { announcements } from './announcements.module'
import { contact } from './contact.module'
import { clientDetails } from './clientDetails.module'
import { payments } from './payments.module'
// import { knowledge } from './knowledge.module'
import { deficiencies } from './deficiencies.module'
import { provinces } from './provinces.module'
import { points } from './points.module'
import { counties } from './counties.module'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        misc,
        menu,
        auth,
        notifications,
        crops,
        crop,
        protectors,
        protector,
        quickSearch,
        modal,
        note,
        agrofags,
        agrofag,
        activeSubstances,
        activeSubstance,
        users,
        user,
        agriiProtectors,
        agriiProtector,
        banner,
        alerts,
        alert,
        photos,
        alertsForUser,
        settings,
        eko,
        termsAndConditions,
        invoices,
        subscriptions,
        announcements,
        contact,
        clientDetails,
        payments,
        // knowledge,
        deficiencies,
        provinces,
        points,
        counties
    }
})

// add extensions support
store.$api = api
store.$storage = localforage
store.$vue = Vue

export default store